var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgRubyGemOutline = function SvgRubyGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.5 110.25L265 90.75L139 199.75L107.5 473.75L209 604.25L439 637.25L582.5 531.25L620.5 259.25L499.5 110.25Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgRubyGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/ruby-gem-outline.7de86179df3e44462ac79cc2ba180940.svg";